import { useEffect, useState } from 'react';
import { useDebouncedValue } from '../hooks/useDebouncedValue';
import './SearchInput.css';

interface Props {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  debounceMs?: number;
}
export function SearchInput({ value, onChange, placeholder = 'Search', debounceMs = 280 }: Props) {
  const [local, setLocal] = useState(value);
  const debounced = useDebouncedValue(local, debounceMs);
  useEffect(() => { if (debounced !== value) onChange(debounced); }, [debounced]); // eslint-disable-line
  useEffect(() => { setLocal(value); }, [value]);
  return (
    <label className="nb-search">
      <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden>
        <circle cx="7" cy="7" r="5" fill="none" stroke="currentColor" strokeWidth="1.4"/>
        <line x1="10.6" y1="10.6" x2="14" y2="14" stroke="currentColor" strokeWidth="1.4"/>
      </svg>
      <input
        type="text"
        value={local}
        onChange={e => setLocal(e.target.value)}
        placeholder={placeholder}
      />
      {local && (
        <button type="button" className="nb-search__clear" onClick={() => setLocal('')} aria-label="clear">×</button>
      )}
    </label>
  );
}
